const headerStyle = (theme) => ({
  header: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    boxSizing: "border-box",
    padding: theme.spacing(1.5, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  subtitle: {
    lineHeight: 1,
  },
  flexRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export default headerStyle;
